module.exports = __webpack_public_path__ + "img/amex.52ad483a.png";